/**
 * CaptionOverlayView — the render layer for the Image block's Text overlay (deck
 * N40). Bucket D / wave D2 / DL-037. Absolutely-positioned inside the image
 * container (which is position:relative), it paints — via the pure captionOverlay
 * model — an optional whole-image darken/lighten layer plus the caption text at
 * one of the 9 grid spots, with the AA readable-contrast guard (scrim / shadow).
 *
 * Renders NOTHING when there is no caption text, so an image with an empty overlay
 * (or none at all) is byte-identical to no overlay.
 *
 * pointer-events:none — the overlay never intercepts the image's existing
 * click/hyperlink/modal behavior.
 */

import React from "react";
import { resolveCaption } from "./captionOverlay";

const CaptionOverlayView = ({ overlay }) => {
  const r = resolveCaption(overlay);
  if (!r.hasText) return null;
  return (
    <>
      {r.imageOverlayStyle && <div style={r.imageOverlayStyle} data-caption-image-overlay aria-hidden="true" />}
      <div style={r.wrapperStyle} data-caption-overlay>
        <span style={r.textStyle} data-caption-text>
          {r.text}
        </span>
      </div>
    </>
  );
};

export default CaptionOverlayView;
